var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"ma-0 pa-0"},[(!_vm.valueAlert)?_c('calendarUser',{attrs:{"type":_vm.type}}):_vm._e(),(_vm.valueAlert)?_c('sucessDiaries'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }